import React from "react";
import ReactSliderBase from "react-slider";

/**
 * Shim for react-slider so TypeScript accepts it as a JSX component.
 */
const ReactSlider = ReactSliderBase as unknown as React.FC<any>;

export default ReactSlider;